/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {UserAuthService} from "./user-auth.service";
import {UserInfo} from "../model/user-info";
import {Observable} from "rxjs";


@Injectable()
export class AuthResolver implements Resolve<UserInfo> {
  constructor(private userAuth: UserAuthService) {}

  resolve(route: ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    return this.userAuth.getUserAuth();
  }
}
